import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";


export const getCurrency = async () => {
    const respuesta = await PrivateInterceptor('Global/Currency', 'GET');
    return respuesta;
}

export const getPublicCurrency = async (token) => {
    const respuesta = await PublicInterceptor('Global/Currency', 'GET',undefined, token);
    return respuesta;
}

export const getCurrencyToken = async (Token) => {
    const result = await PublicInterceptor(`Global/Currency/Monedas/token`, 'GET', {}, Token);
    return result;
}